export enum Flags {
  DischargeQuestions = 'discharge_questions',
  AltcsPending = 'altcs_pending',
  ComparisonForAiSummary = 'comparison_for_ai_summary',
  InboundReferrals = 'inbound_referrals',
  InboundReferralNotifications = 'inbound_referral_notifications',
  InAppNotifications = 'in_app_notifications',
  PushNotificationsPoc = 'push_notifications_poc',
  PushNotifications = 'push_notifications',
}
